import React, { useState, useEffect } from "react";

const SessionNoticePublic = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const noticeMessage = window._env_?.PUBLIC_NOTICE;
    const noticeVersion = window._env_?.PUBLIC_NOTICE_VERSION || "1.0";
    
    if (!noticeMessage) {
      setIsVisible(false);
      return;
    }

    const dismissedVersion = localStorage.getItem("publicNoticeDismissedVersion");
    
    if (dismissedVersion !== noticeVersion) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    const noticeVersion = window._env_?.PUBLIC_NOTICE_VERSION || "1.0";
    localStorage.setItem("publicNoticeDismissedVersion", noticeVersion);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const noticeMessage = window._env_?.PUBLIC_NOTICE;

  return (
    <div className="notification is-warning is-light" style={{ margin: "1rem", position: "relative" }}>
      <button className="delete" onClick={handleDismiss}></button>
      <div dangerouslySetInnerHTML={{ __html: noticeMessage }} />
    </div>
  );
};

export default SessionNoticePublic;
